import styled from 'styled-components';
import { cp2_pink } from '../../Theme/colors';

export const BottomNav = styled.div`
  background-color: ${cp2_pink};
  color: ${cp2_pink};
  padding-bottom: calc(constant(safe-area-inset-bottom) - 15px); /* iOS 11.0 */
  padding-bottom: calc(env(safe-area-inset-bottom) - 15px); /* iOS 11.2 */
`;
